// CacheKey e4fe71da8dd58b87032410ea1597b87f
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-ACCOUNT_STRATEGY": {
    simple_form: {
      labels: {
        defaults: {
          captain: "Advisor",
          first_name: "System",
          last_name: "Facility"
        },
        encounter: {
          arrival_date: "Product Launch Date",
          bed_number: "Product",
          discharge_date: "Product End Date",
          encounter_class: "Product Class",
          encounter_id: "Product ID",
          expected_arrival_date: "Expected Product Launch Date",
          facility: "Building",
          hospital_service: "Salesforce Product ID",
          length_of_stay: "Days Live",
          previous_discharge_date: "Previous Product End Date",
          room: "Product Family"
        },
        patient: {
          encounter_id: "Product ID",
          first_name: "System",
          date_of_birth: "Date of First Contract Signature",
          date_of_death: "End of Term Date",
          primary_language: "Salesforce Account ID"
        },
        unit: {
          facility: "Building"
        }
      }
    }
  }
}

